import { Controller } from '@hotwired/stimulus';

export default class AccordionItemController extends Controller {
  static targets = ['valueDisplay'];
  static values = { emptyState: String };

  _displayValues = new Map();

  connect() {
    if (!this.valueDisplayTarget.innerText.trim()) {
      this.valueDisplayTarget.innerText = this.emptyStateValue;
    }
  }

  disconnect() {
    this._displayValues.clear();
  }

  onChange(event) {
    this._displayValues.set(event.target, event.detail.displayValue);
    const activeValues = [...this._displayValues.values()].filter(Boolean);
    this.valueDisplayTarget.innerText = activeValues.join(', ') || this.emptyStateValue;
  }
}
